// EN / DE / TR translations for EMKA Group landing
export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      catalogs: "Catalogs",
      contact: "Contact",
    },
    catalogs: {
      metal: "EMKA Metal",
      urban: "EMKA Urban",
      plastics: "EMKA Plastics",
      packaging: "EMKA Packaging",
      lighting: "EMKA Lighting",
      brochuresLabel: "Brochures",
      brochureLighting: "Lighting Catalog",
      brochureHeating: "Heating Catalog",
      brochureUrban: "Urban Catalog",
    },
    brochures: {
      urban: {
        eyebrow: "Catalog",
        title: "EMKA Urban BG",
        tagline: "Functional, aesthetic and sustainable solutions for modern cities",
        aboutTitle: "About EMKA Urban BG",
        aboutBody:
          "EMKA Urban BG creates functional, aesthetic and sustainable urban furniture solutions that enhance the quality of city life. With durable materials, functional designs and attention to detail, we add value to public spaces. We design for cities, we build for life.",
        advantagesTitle: "Product Features",
        advantages: [
          "Durable materials",
          "Weather resistant",
          "Easy maintenance",
          "Anti-vandal",
          "TSE certified",
          "UV resistant, recyclable & easy to install",
        ],
        categoriesTitle: "Product Categories",
        categories: [
          "Waste Bins",
          "Benches",
          "Picnic Tables",
          "Planters",
          "Bicycle Racks",
          "Bollards & Barriers",
          "Lighting",
        ],
        specsTitle: "Finishes & Materials",
        specs: [
          "RAL 7016 Anthracite Grey",
          "RAL 9005 Jet Black",
          "RAL 7021 Black Grey",
          "RAL 7043 Traffic Grey",
          "RAL 6005 Moss Green",
          "Corten Effect · Iroko / Thermo Wood",
        ],
        ctaTitle: "Request the full catalog",
        ctaBody:
          "Download the 2024 EMKA Urban product catalog or contact us for project-specific solutions.",
      },
      lighting: {
        eyebrow: "Catalog",
        title: "EMKA Outdoor Solutions",
        tagline: "Urban Lighting & Street Furniture",
        aboutTitle: "About EMKA Outdoor Solutions",
        aboutBody:
          "A leading manufacturer of urban lighting and street furniture. We produce high-quality, modern and durable solutions from our production facility in Türkiye and support European customers from our sales office in Sofia, Bulgaria.",
        advantagesTitle: "Our Advantages",
        advantages: [
          "Production in Türkiye — high quality and competitive",
          "EU sales office in Sofia, Bulgaria",
          "Fast & reliable service, on-time delivery",
          "Custom production for special projects",
          "CE certified products",
        ],
        categoriesTitle: "Product Categories",
        categories: [
          "Modern Bollard Lights",
          "Diffuser Lights",
          "Decorative Garden Lights",
          "Architectural Series",
          "Premium Series",
          "Techno Series",
          "Wood & Deck Series",
          "Outdoor & Garden Mini Lights",
          "Laser Design Collections",
          "Special Project Lighting",
          "Special Bollards",
          "Decorative Pole Lights",
        ],
        ctaTitle: "Request the full catalog",
        ctaBody:
          "We produce special designs for your projects. Send us your drawings (DWG / STEP / PDF) and we will prepare the best solution.",
      },
      heating: {
        eyebrow: "Catalog",
        title: "EMKA Heating",
        tagline: "Complete Range of Heating & Metal Products",
        aboutTitle: "About EMKA Heating",
        aboutBody:
          "A Turkish manufacturer with a strong production network in Türkiye and a sales office in Sofia, Bulgaria. We produce high-quality metal products combining modern design, durability and efficiency.",
        advantagesTitle: "Why EMKA Group",
        advantages: [
          "Competitive prices with high-quality standards",
          "Flexible production and custom designs",
          "On-time delivery with strong logistics",
          "Dedicated support before and after sales",
          "Long-term and sustainable partnership",
        ],
        categoriesTitle: "Product Categories",
        categories: [
          "Pellet Stoves — 5–9 kW, up to 90% efficiency",
          "Fire Pits — stainless steel, grill compatible",
          "Pellet Heaters — indoor & outdoor",
          "Metal Accessories — garden, home, organization",
        ],
        specsTitle: "At a Glance",
        specs: [
          "Heating capacity: 5–9 kW",
          "Efficiency: up to 90%",
          "Fuel: pellet / wood",
          "Steel & stainless steel construction",
          "2-year warranty",
          "Indoor / outdoor applications",
        ],
        ctaTitle: "Get a quote",
        ctaBody:
          "Ask for pricing, technical drawings or shipping options for the European market.",
      },
    },
    hero: {
      line1: "YOUR RELIABLE",
      line2: "MANUFACTURING",
      line3: "PARTNER IN EUROPE",
      sub1: "Production Network in Türkiye",
      sub2: "European Sales Office in Sofia, Bulgaria",
      adv1: "Strong Production in Türkiye",
      adv2: "European Sales Office in Sofia, Bulgaria",
      adv3: "Fast & Flexible Logistics to Europe",
      adv4: "High Quality Competitive Pricing",
    },
    units: {
      eyebrow: "OUR BUSINESS UNITS",
      title: "FIVE STRONG DIVISIONS, ONE RELIABLE PARTNER",
      viewMore: "VIEW MORE",
      metal: {
        title: "METAL",
        items: [
          "Sheet Metal Processing",
          "Laser Cutting (6kW)",
          "Tube Laser Cutting (3kW)",
          "CNC Machining",
          "Bending & Forming",
          "Welding & Assembly",
          "Raw Material Supply",
        ],
      },
      urban: {
        title: "URBAN",
        items: [
          "Urban Furniture",
          "Benches",
          "Waste Bins",
          "Bicycle Racks",
          "Bollards",
          "Custom Municipal Solutions",
          "Design & Production",
        ],
      },
      plastics: {
        title: "PLASTICS",
        items: [
          "Plastic Components",
          "Custom Injection Parts",
          "Industrial Plastic Products",
          "Transport & Logistic Accessories",
          "High Quality Production",
        ],
      },
      packaging: {
        title: "PACKAGING",
        items: [
          "Corrugated Boxes",
          "Custom Packaging",
          "Industrial Packaging",
          "Printed Packaging",
          "Protective Solutions",
          "Sustainable Production",
        ],
      },
      lighting: {
        title: "LIGHTING",
        items: [
          "Outdoor Lighting",
          "Bollard Lights",
          "Decorative Lighting",
          "Street & Park Lighting",
          "Custom Project Lighting",
          "High Efficiency LED Solutions",
        ],
      },
    },
    stats: {
      experience: { value: "20+", label: "YEARS OF EXPERIENCE" },
      employees: { value: "20+", label: "PARTNERS" },
      machines: { value: "30+", label: "MODERN CNC MACHINES" },
      countries: { value: "25+", label: "COUNTRIES WE SERVE" },
      satisfaction: { value: "100%", label: "CUSTOMER SATISFACTION" },
    },
    footer: {
      tagline: "Your reliable manufacturing partner in Europe.",
      quickLinks: "Quick Links",
      divisions: "Divisions",
      contact: "Contact",
      address: "Production: Türkiye  •  Sales Office: Sofia, Bulgaria",
      rights: "All rights reserved.",
    },
    category: {
      backHome: "Back to Home",
      overview: "Overview",
      capabilities: "Capabilities",
      applicationsTitle: "Application Areas",
      featuresTitle: "Why Choose Us",
      ctaTitle: "Need a custom quote?",
      ctaText:
        "Reach out to our team and get a tailored offer for your project in Europe.",
      ctaButton: "Contact Us",
      metal: {
        tagline: "Precision Sheet Metal Processing",
        intro:
          "EMKA Metal delivers precision sheet metal processing, laser cutting and CNC machining for industrial customers across Europe.",
        descriptionHtml:
          "<p>Under EMKA Metal, we combine high-power fibre laser cutting, tube laser cutting, CNC bending and welded fabrication under one roof. From single prototype parts to serial industrial production, every piece leaves the shop floor with tight tolerances and a documented quality trail.</p><p>Our production is backed by an experienced engineering team that reads your technical drawings, proposes production-friendly revisions when needed, and delivers on time with competitive European pricing.</p>",
        applications: [
          "Automotive & mobility",
          "Machinery & industrial equipment",
          "Energy & infrastructure",
          "Steel construction",
          "Consumer appliances",
          "Custom OEM projects",
        ],
        features: [
          "6kW & 3kW fibre laser cutting",
          "Full engineering support",
          "In-house welding & assembly",
          "Raw material supply",
          "European delivery from Türkiye",
          "Tight-tolerance CNC machining",
        ],
      },
      urban: {
        tagline: "Durable Urban Furniture & Municipal Solutions",
        intro:
          "EMKA Urban designs and manufactures durable urban furniture and municipal solutions — benches, bins, bollards and bicycle racks.",
        descriptionHtml:
          "<p>EMKA Urban delivers weather-resistant, high-durability outdoor furniture for parks, promenades and city projects across Europe. Every piece is engineered for long service life with minimal maintenance and consistent visual identity.</p><p>We work with municipalities, landscape architects and construction contractors — from off-the-shelf catalogue items to fully custom designs based on your project brief.</p>",
        applications: [
          "City parks & promenades",
          "Municipal streetscape projects",
          "Residential developments",
          "Shopping & mixed-use areas",
          "University & school campuses",
          "Corporate campuses",
        ],
        features: [
          "Weather-resistant materials",
          "Long service life",
          "Custom project design",
          "In-house metal + wood assembly",
          "Consistent visual identity",
          "Fast European delivery",
        ],
      },
      plastics: {
        tagline: "Custom Plastic Components & Injection Parts",
        intro:
          "EMKA Plastics produces custom plastic components and injection parts for industrial, transport and logistics applications.",
        descriptionHtml:
          "<p>EMKA Plastics manufactures precision-moulded plastic components for industrial machinery, transport equipment and logistics accessories. We support customers from prototype development through to full-scale production runs.</p><p>Our team helps optimise part designs for mould-ability, material selection and cost — while ensuring every batch meets consistent dimensional and mechanical requirements.</p>",
        applications: [
          "Industrial machinery",
          "Transport & logistics",
          "Automotive accessories",
          "Consumer products",
          "Electrical enclosures",
          "OEM assemblies",
        ],
        features: [
          "Custom injection moulding",
          "Design-for-manufacture support",
          "Material selection guidance",
          "Serial production capacity",
          "Consistent dimensional accuracy",
          "Sustainable material options",
        ],
      },
      packaging: {
        tagline: "Corrugated, Printed & Protective Packaging",
        partner: "Varolpack — European Sales Representative",
        intro:
          "EMKA Packaging produces corrugated, printed and protective packaging for industrial and consumer products.",
        descriptionHtml:
          "<p>EMKA Packaging supplies corrugated boxes, printed retail packaging, industrial protective solutions and custom transport packaging. Every product is engineered to protect your goods while presenting your brand at its best.</p><p>From single-wall shipping cartons to multi-layer printed packaging, we support flexible order quantities and quick turnaround for both stock and custom formats.</p>",
        applications: [
          "E-commerce shipping",
          "Retail & consumer goods",
          "Industrial spare parts",
          "Automotive & machinery",
          "Food & beverage secondary packaging",
          "Transport & logistics",
        ],
        features: [
          "Custom sizing & printing",
          "Protective inserts & dividers",
          "Sustainable materials",
          "Flexible order quantities",
          "Fast turnaround",
          "European-grade quality",
        ],
      },
      lighting: {
        tagline: "High-Efficiency Outdoor LED Lighting",
        intro:
          "EMKA Lighting delivers high-efficiency outdoor LED lighting — bollards, street, park and custom project lighting.",
        descriptionHtml:
          "<p>EMKA Lighting designs and manufactures outdoor LED fixtures — bollard lights, street lights, park lights and custom architectural lighting. Every fixture is engineered for high efficiency, long lifetime and low maintenance.</p><p>We support urban planners, landscape architects and contractors with photometric layouts, custom finishes and project-specific mounting solutions.</p>",
        applications: [
          "Parks, gardens & promenades",
          "Streets & pedestrian areas",
          "Residential developments",
          "Corporate & campus lighting",
          "Retail & commercial spaces",
          "Architectural projects",
        ],
        features: [
          "High-efficiency LED drivers",
          "Long service life",
          "Weather-sealed housings",
          "Custom finishes & colours",
          "Photometric layout support",
          "Project-specific mounting",
        ],
      },
    },
    contact: {
      heroTitle: "Let's build something together.",
      heroIntro:
        "Tell us about your project — technical drawings, sample requirements or a rough scope. Our team in Sofia gets back to you within one business day.",
      companySubtitle: "European Sales & Operations",
      labels: {
        address: "Address",
        vat: "VAT",
        sales: "Sales",
        web: "Web",
        email: "Email",
        linkedin: "LinkedIn",
        phone: "Phone",
      },
      precisionEyebrow: "Precision Manufacturing",
      precisionBody:
        "Laser Cutting · CNC Machining · Steel Fabrication",
      personRole: "Founder & Managing Director",
      personCompany: "EMKA Group Europe · Sofia, Bulgaria",
      quickFacts: {
        response: "Response within 1 business day",
        location: "Production in Türkiye · Sales in Sofia",
        support: "Custom quotes with engineering support",
      },
      formEyebrow: "Send us a message",
      formTitle: "Tell us about your project",
      formSubtitle:
        "Fill in the form and our team will reach out with a tailored proposal.",
      fields: {
        name: "Full name",
        namePh: "Jane Doe",
        company: "Company",
        companyPh: "Company name",
        email: "Work email",
        emailPh: "name@company.com",
        phone: "Phone",
        optional: "optional",
        phonePh: "+90 000 000 00 00",
        interest: "I'm interested in",
        interestPh: "Select a division…",
        message: "Project details",
        messagePh:
          "Materials, quantities, timeline, drawings you can share…",
        generalEnquiry: "General enquiry",
      },
      privacy:
        "By sending, you agree to be contacted about your enquiry. We never share your details.",
      submit: "Send message",
      successTitle: "Thank you!",
      successBody:
        "Your message has been received. Our team in Sofia will get back to you within one business day at the email you provided.",
      sendAnother: "Send another message",
    },
    about: {
      eyebrow: "About Us",
      heroTitle: "Strong Production, Reliable Solutions",
      introHtml:
        "<p>EMKA Group is an international manufacturing and engineering group operating in metal processing, engineering and industrial production, delivering high-quality manufacturing and supply solutions to its customers.</p><p>By combining our strong production infrastructure in Türkiye with our European sales and operations centre in Bulgaria, we offer fast communication, efficient logistics management and competitive commercial solutions to our customers across Europe.</p><p>Our production capabilities include laser cutting, tube and profile laser cutting, CNC bending, welded fabrication, machining, steel construction, metal forming, surface treatment, electrostatic powder coating, galvanizing and project-specific metal production.</p><p>EMKA Group goes beyond standard manufacturing and develops custom production solutions that match customers' technical drawings, samples and project requirements. Thanks to our engineering approach, quality-focused production mindset and strong supply chain, we aim to deliver every project on time and at the required quality level.</p><p>We add value to customers operating in automotive, machinery, energy, logistics, infrastructure, construction, urban furniture and industrial equipment sectors with flexible production capacity, a sustainable quality mindset and a long-term partnership approach.</p><p>We see every project not just as a production process but as a long-term collaboration that contributes to our customers' success. In line with the principles of trust, transparency, quality and sustainability, we continue to be a reliable solution partner in the international market.</p>",
      visionTitle: "Our Vision",
      visionHtml:
        "<p>To be one of the leading manufacturing groups preferred in the international market — standing out with quality, trust and a sustainable production mindset, driven by engineering strength, an innovative approach and customer-focused service.</p>",
      missionTitle: "Our Mission",
      missionHtml:
        "<p>To accurately analyse our customers' needs and generate lasting value through high-quality production, competitive pricing, on-time delivery and a professional service mindset.</p>",
      valuesTitle: "Our Values",
      valuesHtml:
        "<ul><li>Quality-focused production</li><li>Reliable partnership</li><li>Customer satisfaction</li><li>Continuous improvement and innovation</li><li>Ethical and transparent trade</li><li>Sustainable production mindset</li><li>On-time delivery</li><li>Engineering and solution-oriented approach</li></ul>",
      whyTitle: "Why EMKA Group?",
      whyHtml:
        "<ul><li>Strong production infrastructure in Türkiye</li><li>Bulgaria-based European sales and operations support</li><li>Wide manufacturer and supplier network</li><li>Project-specific engineering and production solutions</li><li>Competitive pricing and cost advantage</li><li>Production compliant with international quality standards</li><li>Flexible production capacity</li><li>Fast quotation and effective project management</li><li>On-time delivery and sustainable partnership</li></ul>",
    },
  },

  de: {
    nav: {
      home: "Startseite",
      about: "Über uns",
      catalogs: "Kataloge",
      contact: "Kontakt",
    },
    catalogs: {
      metal: "EMKA Metal",
      urban: "EMKA Urban",
      plastics: "EMKA Plastics",
      packaging: "EMKA Packaging",
      lighting: "EMKA Lighting",
      brochuresLabel: "Broschüren",
      brochureLighting: "Beleuchtungskatalog",
      brochureHeating: "Heizungskatalog",
      brochureUrban: "Urban-Katalog",
    },
    brochures: {
      urban: {
        eyebrow: "Katalog",
        title: "EMKA Urban BG",
        tagline: "Funktionale, ästhetische und nachhaltige Lösungen für moderne Städte",
        aboutTitle: "Über EMKA Urban BG",
        aboutBody:
          "EMKA Urban BG entwickelt funktionale, ästhetische und nachhaltige Stadtmöbel-Lösungen, die die Lebensqualität in Städten erhöhen. Mit langlebigen Materialien, funktionalem Design und Liebe zum Detail schaffen wir Mehrwert für den öffentlichen Raum. Wir gestalten für Städte, wir bauen für das Leben.",
        advantagesTitle: "Produkteigenschaften",
        advantages: [
          "Langlebige Materialien",
          "Witterungsbeständig",
          "Wartungsarm",
          "Vandalismussicher",
          "TSE-zertifiziert",
          "UV-beständig, recycelbar & leicht zu installieren",
        ],
        categoriesTitle: "Produktkategorien",
        categories: [
          "Mülleimer",
          "Bänke",
          "Picknicktische",
          "Pflanzgefäße",
          "Fahrradständer",
          "Poller & Absperrungen",
          "Beleuchtung",
        ],
        specsTitle: "Oberflächen & Materialien",
        specs: [
          "RAL 7016 Anthrazitgrau",
          "RAL 9005 Tiefschwarz",
          "RAL 7021 Schwarzgrau",
          "RAL 7043 Verkehrsgrau",
          "RAL 6005 Moosgrün",
          "Corten-Effekt · Iroko / Thermoholz",
        ],
        ctaTitle: "Katalog anfordern",
        ctaBody:
          "Laden Sie den EMKA Urban Produktkatalog 2024 herunter oder kontaktieren Sie uns für projektspezifische Lösungen.",
      },
      lighting: {
        eyebrow: "Katalog",
        title: "EMKA Outdoor Solutions",
        tagline: "Stadtbeleuchtung & Straßenmöbel",
        aboutTitle: "Über EMKA Outdoor Solutions",
        aboutBody:
          "Ein führender Hersteller von Stadtbeleuchtung und Straßenmöbeln. Wir fertigen hochwertige, moderne und langlebige Lösungen in unserem Werk in der Türkei und betreuen europäische Kunden von unserem Vertriebsbüro in Sofia, Bulgarien.",
        advantagesTitle: "Unsere Vorteile",
        advantages: [
          "Produktion in der Türkei — hohe Qualität, wettbewerbsfähig",
          "EU-Vertriebsbüro in Sofia, Bulgarien",
          "Schneller & zuverlässiger Service, pünktliche Lieferung",
          "Sonderfertigung für spezielle Projekte",
          "CE-zertifizierte Produkte",
        ],
        categoriesTitle: "Produktkategorien",
        categories: [
          "Moderne Pollerleuchten",
          "Diffusor-Leuchten",
          "Dekorative Gartenleuchten",
          "Architektur-Serie",
          "Premium-Serie",
          "Techno-Serie",
          "Wood & Deck-Serie",
          "Outdoor- & Garten-Mini-Leuchten",
          "Laser-Design-Kollektionen",
          "Sonderprojekt-Beleuchtung",
          "Sonder-Poller",
          "Dekorative Mastleuchten",
        ],
        ctaTitle: "Vollständigen Katalog anfordern",
        ctaBody:
          "Wir fertigen Sonderdesigns für Ihre Projekte. Senden Sie uns Ihre Zeichnungen (DWG / STEP / PDF) und wir erstellen die beste Lösung.",
      },
      heating: {
        eyebrow: "Katalog",
        title: "EMKA Heating",
        tagline: "Komplettes Sortiment an Heiz- & Metallprodukten",
        aboutTitle: "Über EMKA Heating",
        aboutBody:
          "Ein türkischer Hersteller mit starkem Produktionsnetzwerk in der Türkei und Vertriebsbüro in Sofia, Bulgarien. Wir fertigen hochwertige Metallprodukte, die modernes Design, Langlebigkeit und Effizienz vereinen.",
        advantagesTitle: "Warum EMKA Group",
        advantages: [
          "Wettbewerbsfähige Preise bei hoher Qualität",
          "Flexible Produktion und Sonderdesigns",
          "Pünktliche Lieferung mit starker Logistik",
          "Umfassende Unterstützung vor und nach dem Verkauf",
          "Langfristige und nachhaltige Partnerschaft",
        ],
        categoriesTitle: "Produktkategorien",
        categories: [
          "Pelletöfen — 5–9 kW, bis zu 90% Effizienz",
          "Feuerstellen — Edelstahl, grillkompatibel",
          "Pellet-Heizer — innen & außen",
          "Metallzubehör — Garten, Haus, Organisation",
        ],
        specsTitle: "Auf einen Blick",
        specs: [
          "Heizleistung: 5–9 kW",
          "Effizienz: bis zu 90%",
          "Brennstoff: Pellet / Holz",
          "Stahl- & Edelstahlkonstruktion",
          "2 Jahre Garantie",
          "Innen- / Außenanwendungen",
        ],
        ctaTitle: "Angebot einholen",
        ctaBody:
          "Fragen Sie nach Preisen, technischen Zeichnungen oder Versandoptionen für den europäischen Markt an.",
      },
    },
    hero: {
      line1: "IHR ZUVERLÄSSIGER",
      line2: "FERTIGUNGSPARTNER",
      line3: "IN EUROPA",
      sub1: "Produktionsnetzwerk in der Türkei",
      sub2: "Europäisches Vertriebsbüro in Sofia, Bulgarien",
      adv1: "Starke Produktion in der Türkei",
      adv2: "Vertriebsbüro in Sofia, Bulgarien",
      adv3: "Schnelle & flexible Logistik nach Europa",
      adv4: "Hohe Qualität, faire Preise",
    },
    units: {
      eyebrow: "UNSERE GESCHÄFTSBEREICHE",
      title: "FÜNF STARKE BEREICHE, EIN ZUVERLÄSSIGER PARTNER",
      viewMore: "MEHR ANZEIGEN",
      metal: {
        title: "METAL",
        items: [
          "Blechbearbeitung",
          "Laserschneiden (6kW)",
          "Rohrlaserschneiden (3kW)",
          "CNC-Bearbeitung",
          "Biegen & Umformen",
          "Schweißen & Montage",
          "Rohstoffversorgung",
        ],
      },
      urban: {
        title: "URBAN",
        items: [
          "Stadtmöbel",
          "Bänke",
          "Abfallbehälter",
          "Fahrradständer",
          "Poller",
          "Kommunale Sonderlösungen",
          "Design & Produktion",
        ],
      },
      plastics: {
        title: "PLASTICS",
        items: [
          "Kunststoffkomponenten",
          "Spritzguss-Sonderteile",
          "Industrielle Kunststoffprodukte",
          "Transport- & Logistikzubehör",
          "Hochwertige Produktion",
        ],
      },
      packaging: {
        title: "PACKAGING",
        items: [
          "Wellpappkartons",
          "Sonderverpackungen",
          "Industrieverpackungen",
          "Bedruckte Verpackungen",
          "Schutzlösungen",
          "Nachhaltige Produktion",
        ],
      },
      lighting: {
        title: "LIGHTING",
        items: [
          "Außenbeleuchtung",
          "Pollerleuchten",
          "Dekorative Beleuchtung",
          "Straßen- & Parkbeleuchtung",
          "Projektbezogene Beleuchtung",
          "Hocheffiziente LED-Lösungen",
        ],
      },
    },
    stats: {
      experience: { value: "20+", label: "JAHRE ERFAHRUNG" },
      employees: { value: "20+", label: "PARTNER" },
      machines: { value: "30+", label: "MODERNE CNC-MASCHINEN" },
      countries: { value: "25+", label: "BELIEFERTE LÄNDER" },
      satisfaction: { value: "100%", label: "KUNDENZUFRIEDENHEIT" },
    },
    footer: {
      tagline: "Ihr zuverlässiger Fertigungspartner in Europa.",
      quickLinks: "Schnellzugriff",
      divisions: "Geschäftsbereiche",
      contact: "Kontakt",
      address: "Produktion: Türkei  •  Vertriebsbüro: Sofia, Bulgarien",
      rights: "Alle Rechte vorbehalten.",
    },
    category: {
      backHome: "Zurück zur Startseite",
      overview: "Überblick",
      capabilities: "Leistungen",
      applicationsTitle: "Anwendungsbereiche",
      featuresTitle: "Warum uns wählen",
      ctaTitle: "Brauchen Sie ein individuelles Angebot?",
      ctaText:
        "Kontaktieren Sie unser Team und erhalten Sie ein maßgeschneidertes Angebot für Ihr Projekt in Europa.",
      ctaButton: "Kontakt aufnehmen",
      metal: {
        tagline: "Präzise Blechbearbeitung",
        intro:
          "EMKA Metal liefert präzise Blechbearbeitung, Laserschneiden und CNC-Bearbeitung für Industriekunden in ganz Europa.",
        descriptionHtml:
          "<p>Unter EMKA Metal vereinen wir leistungsstarkes Faserlaserschneiden, Rohrlaserschneiden, CNC-Biegen und Schweißkonstruktion unter einem Dach. Von Prototypen bis zur Serienfertigung verlässt jedes Teil unsere Produktion mit engen Toleranzen und dokumentierter Qualität.</p><p>Unsere Produktion wird von einem erfahrenen Ingenieurteam unterstützt, das Ihre technischen Zeichnungen prüft, produktionsfreundliche Anpassungen vorschlägt und pünktlich zu wettbewerbsfähigen europäischen Preisen liefert.</p>",
        applications: [
          "Automobil & Mobilität",
          "Maschinenbau & Industrieausrüstung",
          "Energie & Infrastruktur",
          "Stahlbau",
          "Haushaltsgeräte",
          "Kundenspezifische OEM-Projekte",
        ],
        features: [
          "6kW & 3kW Faserlaserschneiden",
          "Umfassende Engineering-Unterstützung",
          "Schweißen & Montage im Haus",
          "Rohstoffversorgung",
          "Europäische Lieferung aus der Türkei",
          "CNC-Bearbeitung mit engen Toleranzen",
        ],
      },
      urban: {
        tagline: "Langlebige Stadtmöbel & kommunale Lösungen",
        intro:
          "EMKA Urban entwirft und fertigt langlebige Stadtmöbel und kommunale Lösungen – Bänke, Mülleimer, Poller und Fahrradständer.",
        descriptionHtml:
          "<p>EMKA Urban liefert witterungsbeständige Außenmöbel mit hoher Lebensdauer für Parks, Promenaden und Stadtprojekte in ganz Europa. Jedes Element ist auf lange Lebensdauer, minimalen Wartungsaufwand und einheitliches Erscheinungsbild ausgelegt.</p><p>Wir arbeiten mit Kommunen, Landschaftsarchitekten und Bauunternehmen zusammen – vom Katalogprodukt bis zu vollständig kundenspezifischen Entwürfen.</p>",
        applications: [
          "Stadtparks & Promenaden",
          "Kommunale Straßenprojekte",
          "Wohnbauprojekte",
          "Einkaufs- und Mischgebiete",
          "Universitäts- & Schulcampus",
          "Firmengelände",
        ],
        features: [
          "Witterungsbeständige Materialien",
          "Lange Lebensdauer",
          "Kundenspezifisches Design",
          "Metall- + Holzmontage im Haus",
          "Einheitliches Erscheinungsbild",
          "Schnelle europäische Lieferung",
        ],
      },
      plastics: {
        tagline: "Kundenspezifische Kunststoffkomponenten & Spritzgussteile",
        intro:
          "EMKA Plastics produziert kundenspezifische Kunststoffkomponenten und Spritzgussteile für Industrie, Transport und Logistik.",
        descriptionHtml:
          "<p>EMKA Plastics fertigt präzisionsgeformte Kunststoffkomponenten für Industriemaschinen, Transportmittel und Logistikzubehör. Wir begleiten Kunden vom Prototyp bis zur Serienfertigung.</p><p>Unser Team optimiert Bauteile hinsichtlich Formbarkeit, Materialauswahl und Kosten – und stellt gleichzeitig konstante Maß- und Materialqualität sicher.</p>",
        applications: [
          "Industriemaschinen",
          "Transport & Logistik",
          "Automobilzubehör",
          "Konsumgüter",
          "Elektrogehäuse",
          "OEM-Baugruppen",
        ],
        features: [
          "Kundenspezifisches Spritzgießen",
          "Design-for-Manufacture-Beratung",
          "Materialauswahl-Unterstützung",
          "Serienproduktionskapazität",
          "Konstante Maßgenauigkeit",
          "Nachhaltige Materialoptionen",
        ],
      },
      packaging: {
        tagline: "Wellpappe, bedruckte & Schutzverpackung",
        partner: "Varolpack — Europäischer Vertriebspartner",
        intro:
          "EMKA Packaging fertigt Wellpapp-, Druck- und Schutzverpackungen für Industrie- und Konsumprodukte.",
        descriptionHtml:
          "<p>EMKA Packaging liefert Wellpappkartons, bedruckte Einzelhandelsverpackungen, industrielle Schutzlösungen und kundenspezifische Transportverpackungen. Jedes Produkt schützt Ihre Ware und präsentiert Ihre Marke bestmöglich.</p><p>Von einwandigen Versandkartons bis zu mehrschichtigen bedruckten Verpackungen unterstützen wir flexible Mengen und kurze Lieferzeiten.</p>",
        applications: [
          "E-Commerce-Versand",
          "Einzelhandel & Konsumgüter",
          "Industrielle Ersatzteile",
          "Automobil & Maschinenbau",
          "Sekundärverpackung Lebensmittel",
          "Transport & Logistik",
        ],
        features: [
          "Kundenspezifische Größen & Druck",
          "Schutzeinsätze & Trennwände",
          "Nachhaltige Materialien",
          "Flexible Mengen",
          "Schnelle Lieferzeiten",
          "Europäische Qualität",
        ],
      },
      lighting: {
        tagline: "Hocheffiziente LED-Außenbeleuchtung",
        intro:
          "EMKA Lighting liefert hocheffiziente LED-Außenbeleuchtung – Poller, Straße, Park und projektbezogene Beleuchtung.",
        descriptionHtml:
          "<p>EMKA Lighting entwirft und fertigt LED-Außenleuchten – Poller-, Straßen-, Park- und individuelle Architekturbeleuchtung. Jede Leuchte ist auf hohe Effizienz, lange Lebensdauer und geringen Wartungsaufwand ausgelegt.</p><p>Wir unterstützen Stadtplaner, Landschaftsarchitekten und Bauherren mit photometrischen Auslegungen, kundenspezifischen Oberflächen und projektbezogenen Montagelösungen.</p>",
        applications: [
          "Parks, Gärten & Promenaden",
          "Straßen & Fußgängerzonen",
          "Wohnbauprojekte",
          "Firmen- & Campus-Beleuchtung",
          "Einzelhandel & Gewerbeflächen",
          "Architekturprojekte",
        ],
        features: [
          "Hocheffiziente LED-Treiber",
          "Lange Lebensdauer",
          "Witterungsgeschützte Gehäuse",
          "Kundenspezifische Farben & Oberflächen",
          "Photometrische Planung",
          "Projektbezogene Montage",
        ],
      },
    },
    contact: {
      heroTitle: "Lassen Sie uns gemeinsam etwas aufbauen.",
      heroIntro:
        "Erzählen Sie uns von Ihrem Projekt — technische Zeichnungen, Musteranforderungen oder eine grobe Beschreibung. Unser Team in Sofia meldet sich innerhalb eines Werktages.",
      companySubtitle: "Europäischer Vertrieb & Betrieb",
      labels: {
        address: "Adresse",
        vat: "USt-IdNr.",
        sales: "Vertrieb",
        web: "Web",
        email: "E-Mail",
        linkedin: "LinkedIn",
        phone: "Telefon",
      },
      precisionEyebrow: "Präzisionsfertigung",
      precisionBody:
        "Laserschneiden · CNC-Bearbeitung · Stahlbau",
      personRole: "Gründer & Geschäftsführer",
      personCompany: "EMKA Group Europe · Sofia, Bulgarien",
      quickFacts: {
        response: "Rückmeldung innerhalb eines Werktages",
        location: "Produktion in der Türkei · Vertrieb in Sofia",
        support: "Individuelle Angebote mit Engineering-Support",
      },
      formEyebrow: "Nachricht senden",
      formTitle: "Erzählen Sie uns von Ihrem Projekt",
      formSubtitle:
        "Füllen Sie das Formular aus und unser Team meldet sich mit einem maßgeschneiderten Angebot.",
      fields: {
        name: "Vollständiger Name",
        namePh: "Max Mustermann",
        company: "Firma",
        companyPh: "Firmenname",
        email: "Geschäfts-E-Mail",
        emailPh: "name@firma.com",
        phone: "Telefon",
        optional: "optional",
        phonePh: "+90 000 000 00 00",
        interest: "Ich interessiere mich für",
        interestPh: "Bereich auswählen…",
        message: "Projektdetails",
        messagePh:
          "Materialien, Mengen, Zeitrahmen, Zeichnungen, die Sie teilen können…",
        generalEnquiry: "Allgemeine Anfrage",
      },
      privacy:
        "Mit dem Absenden erklären Sie sich einverstanden, zu Ihrer Anfrage kontaktiert zu werden. Wir geben Ihre Daten niemals weiter.",
      submit: "Nachricht senden",
      successTitle: "Vielen Dank!",
      successBody:
        "Ihre Nachricht ist bei uns eingegangen. Unser Team in Sofia meldet sich innerhalb eines Werktages unter der angegebenen E-Mail-Adresse.",
      sendAnother: "Weitere Nachricht senden",
    },
    about: {
      eyebrow: "Über uns",
      heroTitle: "Starke Produktion, Zuverlässige Lösungen",
      introHtml:
        "<p>EMKA Group ist eine internationale Fertigungs- und Ingenieurgruppe, die in der Metallverarbeitung, Konstruktion und industriellen Fertigung tätig ist und ihren Kunden Produktions- und Beschaffungslösungen auf höchstem Qualitätsniveau bietet.</p><p>Durch die Verbindung unserer starken Produktionsinfrastruktur in der Türkei mit unserem europäischen Vertriebs- und Betriebszentrum in Bulgarien bieten wir unseren Kunden in ganz Europa schnelle Kommunikation, effizientes Logistikmanagement und wettbewerbsfähige kommerzielle Lösungen.</p><p>Unsere Produktionsfähigkeiten umfassen Laserschneiden, Rohr- und Profillaserschneiden, CNC-Biegen, Schweißkonstruktionen, Zerspanung, Stahlbau, Metallumformung, Oberflächenbehandlung, elektrostatische Pulverbeschichtung, Verzinkung und projektspezifische Metallfertigung.</p><p>EMKA Group geht über die Standardfertigung hinaus und entwickelt individuelle Produktionslösungen, die zu den technischen Zeichnungen, Mustern und Projektanforderungen der Kunden passen. Dank unseres Engineering-Ansatzes, unserer qualitätsorientierten Produktionsphilosophie und unserer starken Lieferkette liefern wir jedes Projekt pünktlich und in der gewünschten Qualität.</p><p>Wir schaffen Mehrwert für Kunden in den Bereichen Automobil, Maschinenbau, Energie, Logistik, Infrastruktur, Bauwesen, Stadtmöblierung und Industrieausrüstung – mit flexibler Produktionskapazität, nachhaltiger Qualitätsphilosophie und einer langfristigen Partnerschaftsstrategie.</p><p>Wir betrachten jedes Projekt nicht nur als Produktionsprozess, sondern als langfristige Zusammenarbeit, die zum Erfolg unserer Kunden beiträgt. Nach den Grundsätzen Vertrauen, Transparenz, Qualität und Nachhaltigkeit sind wir weiterhin ein verlässlicher Lösungspartner auf dem internationalen Markt.</p>",
      visionTitle: "Unsere Vision",
      visionHtml:
        "<p>Eine der führenden Fertigungsgruppen auf dem internationalen Markt zu sein – herausragend durch Qualität, Vertrauen und ein nachhaltiges Produktionsverständnis, angetrieben von Ingenieurskompetenz, innovativen Ansätzen und kundenorientiertem Service.</p>",
      missionTitle: "Unsere Mission",
      missionHtml:
        "<p>Die Bedürfnisse unserer Kunden präzise zu analysieren und durch qualitativ hochwertige Produktion, wettbewerbsfähige Preise, pünktliche Lieferung und professionellen Service nachhaltigen Wert zu schaffen.</p>",
      valuesTitle: "Unsere Werte",
      valuesHtml:
        "<ul><li>Qualitätsorientierte Produktion</li><li>Zuverlässige Partnerschaft</li><li>Kundenzufriedenheit</li><li>Kontinuierliche Verbesserung und Innovation</li><li>Ethischer und transparenter Handel</li><li>Nachhaltige Produktionsphilosophie</li><li>Pünktliche Lieferung</li><li>Engineering- und lösungsorientierter Ansatz</li></ul>",
      whyTitle: "Warum EMKA Group?",
      whyHtml:
        "<ul><li>Starke Produktionsinfrastruktur in der Türkei</li><li>Europäische Vertriebs- und Betriebsunterstützung mit Sitz in Bulgarien</li><li>Umfangreiches Hersteller- und Lieferantennetzwerk</li><li>Projektspezifische Engineering- und Produktionslösungen</li><li>Wettbewerbsfähige Preise und Kostenvorteil</li><li>Produktion nach internationalen Qualitätsstandards</li><li>Flexible Produktionskapazität</li><li>Schnelle Angebotserstellung und effektives Projektmanagement</li><li>Pünktliche Lieferung und nachhaltige Partnerschaft</li></ul>",
    },
  },

  tr: {
    nav: {
      home: "Anasayfa",
      about: "Hakkımızda",
      catalogs: "Kataloglar",
      contact: "İletişim",
    },
    catalogs: {
      metal: "EMKA Metal",
      urban: "EMKA Urban",
      plastics: "EMKA Plastics",
      packaging: "EMKA Packaging",
      lighting: "EMKA Lighting",
      brochuresLabel: "Kataloglar",
      brochureLighting: "Aydınlatma Kataloğu",
      brochureHeating: "Isıtma Kataloğu",
      brochureUrban: "Urban Kataloğu",
    },
    brochures: {
      urban: {
        eyebrow: "Katalog",
        title: "EMKA Urban BG",
        tagline: "Modern şehirler için işlevsel, estetik ve sürdürülebilir çözümler",
        aboutTitle: "EMKA Urban BG Hakkında",
        aboutBody:
          "EMKA Urban BG; şehir yaşam kalitesini artıran işlevsel, estetik ve sürdürülebilir kentsel mobilya çözümleri üretir. Dayanıklı malzemeler, işlevsel tasarımlar ve detaylara verilen özenle kamusal alanlara değer katıyoruz. Şehirler için tasarlar, yaşam için üretiriz.",
        advantagesTitle: "Ürün Özellikleri",
        advantages: [
          "Dayanıklı malzemeler",
          "Hava koşullarına dirençli",
          "Kolay bakım",
          "Anti-vandal",
          "TSE sertifikalı",
          "UV dayanıklı, geri dönüşümlü ve kolay montaj",
        ],
        categoriesTitle: "Ürün Kategorileri",
        categories: [
          "Çöp Kutuları",
          "Banklar",
          "Piknik Masaları",
          "Saksılar",
          "Bisiklet Parkları",
          "Bollard & Bariyerler",
          "Aydınlatma",
        ],
        specsTitle: "Kaplama ve Malzemeler",
        specs: [
          "RAL 7016 Antrasit Gri",
          "RAL 9005 Jet Siyah",
          "RAL 7021 Siyah Gri",
          "RAL 7043 Trafik Grisi",
          "RAL 6005 Yosun Yeşili",
          "Corten Efekti · Iroko / Termowood",
        ],
        ctaTitle: "Katalog talep edin",
        ctaBody:
          "2024 EMKA Urban ürün kataloğunu indirin veya projeye özel çözümler için bizimle iletişime geçin.",
      },
      lighting: {
        eyebrow: "Katalog",
        title: "EMKA Outdoor Solutions",
        tagline: "Kentsel Aydınlatma & Sokak Mobilyaları",
        aboutTitle: "EMKA Outdoor Solutions Hakkında",
        aboutBody:
          "Kentsel aydınlatma ve sokak mobilyaları alanında öncü bir üretici. Türkiye'deki üretim tesisimizde yüksek kaliteli, modern ve dayanıklı çözümler üretiyor; Sofya, Bulgaristan'daki satış ofisimizden Avrupa'daki müşterilere hizmet veriyoruz.",
        advantagesTitle: "Avantajlarımız",
        advantages: [
          "Türkiye'de üretim — yüksek kalite, rekabetçi",
          "Sofya'da AB satış ofisi",
          "Hızlı ve güvenilir hizmet, zamanında teslimat",
          "Özel projelere yönelik özel üretim",
          "CE sertifikalı ürünler",
        ],
        categoriesTitle: "Ürün Kategorileri",
        categories: [
          "Modern Bollard Aydınlatmalar",
          "Difüzör Aydınlatmalar",
          "Dekoratif Bahçe Aydınlatmaları",
          "Mimari Seri",
          "Premium Seri",
          "Techno Seri",
          "Wood & Deck Seri",
          "Dış Mekan & Bahçe Mini Aydınlatma",
          "Lazer Tasarım Koleksiyonları",
          "Özel Proje Aydınlatmaları",
          "Özel Bollardlar",
          "Dekoratif Direk Aydınlatmaları",
        ],
        ctaTitle: "Katalog talep edin",
        ctaBody:
          "Projeleriniz için özel tasarımlar üretiyoruz. Çizimlerinizi (DWG / STEP / PDF) gönderin, size en iyi çözümü hazırlayalım.",
      },
      heating: {
        eyebrow: "Katalog",
        title: "EMKA Heating",
        tagline: "Isıtma ve Metal Ürünlerinde Tam Ürün Gamı",
        aboutTitle: "EMKA Heating Hakkında",
        aboutBody:
          "Türkiye'deki güçlü üretim ağı ve Sofya, Bulgaristan'daki satış ofisi ile Türk üretici. Modern tasarım, dayanıklılık ve verimliliği bir araya getiren yüksek kaliteli metal ürünler üretiyoruz.",
        advantagesTitle: "Neden EMKA Group",
        advantages: [
          "Yüksek kalite standardında rekabetçi fiyatlar",
          "Esnek üretim ve özel tasarımlar",
          "Güçlü lojistik ile zamanında teslimat",
          "Satış öncesi ve sonrası tam destek",
          "Uzun vadeli ve sürdürülebilir iş birliği",
        ],
        categoriesTitle: "Ürün Kategorileri",
        categories: [
          "Pellet Sobalar — 5–9 kW, %90'a kadar verim",
          "Fire Pit — paslanmaz çelik, ızgara uyumlu",
          "Pellet Isıtıcılar — iç ve dış mekan",
          "Metal Aksesuarlar — bahçe, ev, düzenleme",
        ],
        specsTitle: "Genel Bakış",
        specs: [
          "Isıtma kapasitesi: 5–9 kW",
          "Verim: %90'a kadar",
          "Yakıt: pellet / odun",
          "Çelik & paslanmaz çelik konstrüksiyon",
          "2 yıl garanti",
          "İç / dış mekan kullanımı",
        ],
        ctaTitle: "Teklif alın",
        ctaBody:
          "Avrupa pazarı için fiyat, teknik çizim veya sevkiyat seçenekleri hakkında bilgi alın.",
      },
    },
    hero: {
      line1: "AVRUPA'DAKİ",
      line2: "GÜVENİLİR ÜRETİM",
      line3: "PARTNERİNİZ",
      sub1: "Türkiye'de Üretim Ağı",
      sub2: "Sofya, Bulgaristan'da Avrupa Satış Ofisi",
      adv1: "Türkiye'de Güçlü Üretim",
      adv2: "Sofya, Bulgaristan Satış Ofisi",
      adv3: "Avrupa'ya Hızlı & Esnek Lojistik",
      adv4: "Yüksek Kalite Rekabetçi Fiyat",
    },
    units: {
      eyebrow: "İŞ BİRİMLERİMİZ",
      title: "BEŞ GÜÇLÜ BÖLÜM, TEK GÜVENİLİR PARTNER",
      viewMore: "DAHA FAZLA",
      metal: {
        title: "METAL",
        items: [
          "Sac Metal İşleme",
          "Lazer Kesim (6kW)",
          "Boru Lazer Kesim (3kW)",
          "CNC İşleme",
          "Büküm & Şekillendirme",
          "Kaynak & Montaj",
          "Hammadde Tedariği",
        ],
      },
      urban: {
        title: "URBAN",
        items: [
          "Kentsel Mobilya",
          "Banklar",
          "Çöp Kutuları",
          "Bisiklet Park Yerleri",
          "Babalar",
          "Özel Belediye Çözümleri",
          "Tasarım & Üretim",
        ],
      },
      plastics: {
        title: "PLASTICS",
        items: [
          "Plastik Bileşenler",
          "Özel Enjeksiyon Parçaları",
          "Endüstriyel Plastik Ürünler",
          "Taşıma & Lojistik Aksesuarları",
          "Yüksek Kaliteli Üretim",
        ],
      },
      packaging: {
        title: "PACKAGING",
        items: [
          "Oluklu Mukavva Kutular",
          "Özel Ambalaj",
          "Endüstriyel Ambalaj",
          "Baskılı Ambalaj",
          "Koruyucu Çözümler",
          "Sürdürülebilir Üretim",
        ],
      },
      lighting: {
        title: "LIGHTING",
        items: [
          "Dış Mekan Aydınlatma",
          "Bollard Aydınlatma",
          "Dekoratif Aydınlatma",
          "Sokak & Park Aydınlatması",
          "Özel Proje Aydınlatması",
          "Yüksek Verimli LED Çözümler",
        ],
      },
    },
    stats: {
      experience: { value: "20+", label: "YILLIK DENEYİM" },
      employees: { value: "20+", label: "PARTNER" },
      machines: { value: "30+", label: "MODERN CNC MAKİNE" },
      countries: { value: "25+", label: "HİZMET VERDİĞİMİZ ÜLKE" },
      satisfaction: { value: "100%", label: "MÜŞTERİ MEMNUNİYETİ" },
    },
    footer: {
      tagline: "Avrupa'daki güvenilir üretim partneriniz.",
      quickLinks: "Hızlı Bağlantılar",
      divisions: "Bölümler",
      contact: "İletişim",
      address: "Üretim: Türkiye  •  Satış Ofisi: Sofya, Bulgaristan",
      rights: "Tüm hakları saklıdır.",
    },
    category: {
      backHome: "Anasayfaya Dön",
      overview: "Genel Bakış",
      capabilities: "Yetkinlikler",
      applicationsTitle: "Uygulama Alanları",
      featuresTitle: "Neden Bizi Seçmelisiniz",
      ctaTitle: "Özel teklif mi gerekiyor?",
      ctaText:
        "Ekibimizle iletişime geçin, Avrupa'daki projeniz için size özel teklif alın.",
      ctaButton: "İletişime Geç",
      metal: {
        tagline: "Hassas Sac Metal İşleme",
        intro:
          "EMKA Metal, Avrupa genelindeki endüstriyel müşteriler için hassas sac metal işleme, lazer kesim ve CNC işleme sunar.",
        descriptionHtml:
          "<p>EMKA Metal çatısı altında yüksek güçlü fiber lazer kesim, boru lazer kesim, CNC büküm ve kaynaklı imalatı tek çatı altında topluyoruz. Prototip parçadan seri endüstriyel üretime kadar her parça, sıkı toleranslar ve belgelenmiş kalite ile üretim hattından çıkar.</p><p>Üretimimiz; teknik resimlerinizi okuyan, gerektiğinde üretime uygun revizyonlar öneren ve rekabetçi Avrupa fiyatlarıyla zamanında teslim eden deneyimli bir mühendislik ekibi tarafından desteklenir.</p>",
        applications: [
          "Otomotiv ve mobilite",
          "Makine ve endüstriyel ekipman",
          "Enerji ve altyapı",
          "Çelik konstrüksiyon",
          "Beyaz eşya ve tüketici ürünleri",
          "Özel OEM projeleri",
        ],
        features: [
          "6kW ve 3kW fiber lazer kesim",
          "Tam mühendislik desteği",
          "Yerinde kaynak ve montaj",
          "Hammadde tedariği",
          "Türkiye'den Avrupa'ya teslimat",
          "Sıkı toleranslı CNC işleme",
        ],
      },
      urban: {
        tagline: "Dayanıklı Kentsel Mobilya ve Belediye Çözümleri",
        intro:
          "EMKA Urban; bank, çöp kutusu, baba ve bisiklet parkı gibi dayanıklı kentsel mobilyalar ile belediye çözümleri tasarlar ve üretir.",
        descriptionHtml:
          "<p>EMKA Urban; Avrupa genelindeki park, sahil bandı ve şehir projeleri için hava koşullarına dayanıklı, uzun ömürlü dış mekan mobilyaları sunar. Her parça, düşük bakım maliyeti ve tutarlı görsel kimlik için tasarlanır.</p><p>Belediyeler, peyzaj mimarları ve inşaat firmaları ile çalışıyoruz — hazır katalog ürünlerden proje brief'inize göre tam özel tasarımlara kadar geniş yelpazede çözüm sunuyoruz.</p>",
        applications: [
          "Kent parkları ve sahil bantları",
          "Belediye sokak projeleri",
          "Konut projeleri",
          "AVM ve karma kullanım alanları",
          "Üniversite ve okul kampüsleri",
          "Kurumsal kampüsler",
        ],
        features: [
          "Hava koşullarına dayanıklı malzemeler",
          "Uzun servis ömrü",
          "Projeye özel tasarım",
          "Yerinde metal + ahşap montaj",
          "Tutarlı görsel kimlik",
          "Hızlı Avrupa teslimatı",
        ],
      },
      plastics: {
        tagline: "Özel Plastik Bileşenler ve Enjeksiyon Parçaları",
        intro:
          "EMKA Plastics; endüstri, taşıma ve lojistik için özel plastik bileşenler ve enjeksiyon parçaları üretir.",
        descriptionHtml:
          "<p>EMKA Plastics; endüstriyel makine, taşıma ekipmanı ve lojistik aksesuarları için hassas kalıplanmış plastik bileşenler üretir. Müşterilere prototip geliştirmeden tam ölçekli seri üretime kadar destek veriyoruz.</p><p>Ekibimiz; parça tasarımlarını kalıplanabilirlik, malzeme seçimi ve maliyet açısından optimize eder — her parti için tutarlı boyutsal ve mekanik gereksinimleri karşıladığından emin oluruz.</p>",
        applications: [
          "Endüstriyel makine",
          "Taşıma ve lojistik",
          "Otomotiv aksesuarları",
          "Tüketici ürünleri",
          "Elektrik kutuları",
          "OEM montajlar",
        ],
        features: [
          "Özel enjeksiyon kalıplama",
          "Üretime uygun tasarım desteği",
          "Malzeme seçimi rehberliği",
          "Seri üretim kapasitesi",
          "Tutarlı boyutsal hassasiyet",
          "Sürdürülebilir malzeme seçenekleri",
        ],
      },
      packaging: {
        tagline: "Oluklu, Baskılı ve Koruyucu Ambalaj",
        partner: "Varolpack — Avrupa Satış Temsilcisi",
        intro:
          "EMKA Packaging; endüstriyel ve tüketici ürünleri için oluklu, baskılı ve koruyucu ambalaj üretir.",
        descriptionHtml:
          "<p>EMKA Packaging; oluklu mukavva kutular, baskılı perakende ambalajları, endüstriyel koruyucu çözümler ve özel taşıma ambalajları tedarik eder. Her ürün, malzemenizi korurken markanızı en iyi şekilde sunmak için tasarlanır.</p><p>Tek katlı sevkiyat kutularından çok katmanlı baskılı ambalajlara kadar; hem stok hem de özel formatlar için esnek sipariş miktarları ve hızlı teslimat sunuyoruz.</p>",
        applications: [
          "E-ticaret gönderileri",
          "Perakende ve tüketici ürünleri",
          "Endüstriyel yedek parça",
          "Otomotiv ve makine",
          "Gıda ve içecek ikincil ambalaj",
          "Taşıma ve lojistik",
        ],
        features: [
          "Özel boyut ve baskı",
          "Koruyucu iç dolgu ve bölmeler",
          "Sürdürülebilir malzemeler",
          "Esnek sipariş miktarları",
          "Hızlı teslimat",
          "Avrupa kalite standardı",
        ],
      },
      lighting: {
        tagline: "Yüksek Verimli Dış Mekan LED Aydınlatma",
        intro:
          "EMKA Lighting; bollard, sokak, park ve özel proje aydınlatması için yüksek verimli LED çözümler sunar.",
        descriptionHtml:
          "<p>EMKA Lighting; dış mekan LED armatürleri tasarlar ve üretir — bollard, sokak, park ve özel mimari aydınlatma. Her armatür yüksek verim, uzun ömür ve düşük bakım için tasarlanır.</p><p>Şehir plancıları, peyzaj mimarları ve müteahhitlere; fotometrik yerleşim desteği, özel yüzey renkleri ve projeye özel montaj çözümleri sunuyoruz.</p>",
        applications: [
          "Parklar, bahçeler ve sahil bantları",
          "Sokaklar ve yaya alanları",
          "Konut projeleri",
          "Kurumsal ve kampüs aydınlatma",
          "Perakende ve ticari alanlar",
          "Mimari projeler",
        ],
        features: [
          "Yüksek verimli LED sürücüler",
          "Uzun servis ömrü",
          "Hava geçirmez muhafazalar",
          "Özel renk ve yüzey",
          "Fotometrik yerleşim desteği",
          "Projeye özel montaj",
        ],
      },
    },
    contact: {
      heroTitle: "Birlikte bir şeyler inşa edelim.",
      heroIntro:
        "Projenizden bahsedin — teknik resimler, numune gereksinimleri veya kısa bir kapsam. Sofya'daki ekibimiz bir iş günü içinde size geri döner.",
      companySubtitle: "Avrupa Satış & Operasyon",
      labels: {
        address: "Adres",
        vat: "Vergi No",
        sales: "Satış",
        web: "Web",
        email: "E-posta",
        linkedin: "LinkedIn",
        phone: "Telefon",
      },
      precisionEyebrow: "Hassas Üretim",
      precisionBody:
        "Lazer Kesim · CNC İşleme · Çelik İmalat",
      personRole: "Kurucu & Genel Müdür",
      personCompany: "EMKA Group Europe · Sofya, Bulgaristan",
      quickFacts: {
        response: "1 iş günü içinde yanıt",
        location: "Türkiye'de üretim · Sofya'da satış",
        support: "Mühendislik destekli özel teklif",
      },
      formEyebrow: "Bize mesaj gönderin",
      formTitle: "Projenizden bahsedin",
      formSubtitle:
        "Formu doldurun; ekibimiz size özel bir teklifle geri dönsün.",
      fields: {
        name: "Ad Soyad",
        namePh: "Adınız Soyadınız",
        company: "Firma",
        companyPh: "Firma adı",
        email: "İş e-postası",
        emailPh: "ad@firma.com",
        phone: "Telefon",
        optional: "opsiyonel",
        phonePh: "+90 000 000 00 00",
        interest: "İlgilendiğim alan",
        interestPh: "Bölüm seçin…",
        message: "Proje detayları",
        messagePh:
          "Malzemeler, miktarlar, zaman planı, paylaşabileceğiniz çizimler…",
        generalEnquiry: "Genel talep",
      },
      privacy:
        "Göndererek, talebiniz hakkında sizinle iletişime geçilmesini kabul edersiniz. Bilgilerinizi asla paylaşmıyoruz.",
      submit: "Mesaj gönder",
      successTitle: "Teşekkürler!",
      successBody:
        "Mesajınız alındı. Sofya'daki ekibimiz bir iş günü içinde belirttiğiniz e-postadan size geri dönecek.",
      sendAnother: "Yeni mesaj gönder",
    },
    about: {
      eyebrow: "Hakkımızda",
      heroTitle: "Güçlü Üretim, Güvenilir Çözümler",
      introHtml:
        "<p>EMKA Group, metal işleme, mühendislik ve endüstriyel üretim alanlarında faaliyet gösteren, müşterilerine yüksek kalite standartlarında üretim ve tedarik çözümleri sunan uluslararası bir üretim ve mühendislik grubudur. Türkiye'deki güçlü üretim altyapımızı, Bulgaristan'daki Avrupa satış ve operasyon merkezimizle birleştirerek; Avrupa genelindeki müşterilerimize hızlı iletişim, etkin lojistik yönetimi ve rekabetçi ticari çözümler sunuyoruz.</p><p>Üretim kabiliyetlerimiz; lazer kesim, boru ve profil lazer kesim, CNC büküm, kaynaklı imalat, talaşlı imalat, çelik konstrüksiyon, metal şekillendirme, yüzey işlemleri, elektrostatik toz boya, galvaniz kaplama ve projeye özel metal üretimlerini kapsamaktadır.</p><p>EMKA Group, standart üretimin ötesine geçerek müşterilerinin teknik resimlerine, numunelerine ve proje gereksinimlerine uygun özel üretim çözümleri geliştirmektedir. Mühendislik yaklaşımımız, kalite odaklı üretim anlayışımız ve güçlü tedarik zincirimiz sayesinde her projeyi zamanında ve istenilen kalite seviyesinde teslim etmeyi hedefliyoruz.</p><p>Otomotiv, makine, enerji, lojistik, altyapı, inşaat, şehir mobilyaları ve endüstriyel ekipman sektörlerinde faaliyet gösteren müşterilerimize; esnek üretim kapasitesi, sürdürülebilir kalite anlayışı ve uzun vadeli iş ortaklığı yaklaşımıyla değer katıyoruz. Her projeyi yalnızca bir üretim süreci olarak değil, müşterilerimizin başarısına katkı sağlayacak uzun vadeli bir iş birliği olarak görüyoruz. Güven, şeffaflık, kalite ve sürdürülebilirlik ilkeleri doğrultusunda uluslararası pazarda güvenilir bir çözüm ortağı olmaya devam ediyoruz.</p>",
      visionTitle: "Vizyonumuz",
      visionHtml:
        "<p>Uluslararası pazarda kalite, güven ve sürdürülebilir üretim anlayışıyla öne çıkan; mühendislik gücü, yenilikçi yaklaşımı ve müşteri odaklı hizmet anlayışıyla tercih edilen lider üretim gruplarından biri olmak.</p>",
      missionTitle: "Misyonumuz",
      missionHtml:
        "<p>Müşterilerimizin ihtiyaçlarını doğru analiz ederek, yüksek kalite standartlarında üretim, rekabetçi fiyatlandırma, zamanında teslimat ve profesyonel hizmet anlayışıyla kalıcı değer üretmek.</p>",
      valuesTitle: "Değerlerimiz",
      valuesHtml:
        "<ul><li>Kalite Odaklı Üretim</li><li>Güvenilir İş Ortaklığı</li><li>Müşteri Memnuniyeti</li><li>Sürekli Gelişim ve Yenilikçilik</li><li>Etik ve Şeffaf Ticaret</li><li>Sürdürülebilir Üretim Anlayışı</li><li>Zamanında Teslimat</li><li>Mühendislik ve Çözüm Odaklı Yaklaşım</li></ul>",
      whyTitle: "Neden EMKA Group?",
      whyHtml:
        "<ul><li>Türkiye'nin güçlü üretim altyapısı</li><li>Bulgaristan merkezli Avrupa satış ve operasyon desteği</li><li>Geniş üretici ve tedarikçi ağı</li><li>Projeye özel mühendislik ve üretim çözümleri</li><li>Rekabetçi fiyatlandırma ve maliyet avantajı</li><li>Uluslararası kalite standartlarına uygun üretim</li><li>Esnek üretim kapasitesi</li><li>Hızlı teklif ve etkin proje yönetimi</li><li>Zamanında teslimat ve sürdürülebilir iş ortaklığı</li></ul>",
    },
  },
};

export const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "tr", label: "TR" },
];
